import { axiosPost } from "./ajaxServices";
import { urlSmsSend, urlSmsSendBulk, urlSmsSendToTeam, urlSmsStats } from "./CONSTANTS";

// Send a single SMS
export const apiSmsSend = ({ token, phone_number, message_text, sender_id, sms_type }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("phone_number", phone_number);
  params.append("message", message_text);
  if (sender_id) params.append("sender_id", sender_id);
  if (sms_type) params.append("sms_type", sms_type);
  return axiosPost(urlSmsSend, params);
};

// Send bulk SMS to an array of phone numbers
export const apiSmsSendBulk = ({ token, phone_numbers, message_text, sender_id, sms_type }) => {
  // Backend expects phone_numbers as a JSON array
  const payload = { token, phone_numbers, message: message_text };
  if (sender_id) payload.sender_id = sender_id;
  if (sms_type) payload.sms_type = sms_type;
  return axiosPost(urlSmsSendBulk, payload);
};

// Send SMS to all members of a team
export const apiSmsSendToTeam = ({ token, team_id, message_text, sender_id }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  params.append("team_id", team_id);
  params.append("message", message_text);
  if (sender_id) params.append("sender_id", sender_id);
  return axiosPost(urlSmsSendToTeam, params);
};

// Get SMS sending statistics
export const apiSmsStats = ({ token }) => {
  const params = new URLSearchParams();
  params.append("token", token);
  return axiosPost(urlSmsStats, params);
};
